module.exports = __webpack_public_path__ + "static/media/w-2_22.3c6ae5dc.png";